import { useEffect } from "react";
import { getUsers } from "../../../api/users";
import { useProductionStore } from "../../../stores/production";
import { Select } from "../../ui/inputs/Select";
import { useUserContext } from "../../../contexts/userContext";
import { showToastError } from "../../../services/toast";

const Users = () => {
    const { formData, setFormData, users, setUsers } =
    useProductionStore();
  const { role, idUser } = useUserContext();

  const handleSelectChange = (e: React.ChangeEvent<HTMLSelectElement>) => {
    setFormData({ ...formData, [e.target.name]: parseInt(e.target.value) });
  };
 
  useEffect(() => {
    getUsers()
      .then((res) => {
        const formattedData = res.data.map((item: any) => ({
          label: item.firstName + " " + item.lastName,
          value: item.id,
        }));
        setUsers(formattedData);

        if(role === "Lecteur") {
          setFormData({ ...formData, idUser: idUser, firstName: users.find((user: any) => user.value === idUser)?.label.split(" ")[0], lastName: users.find((user: any) => user.value === idUser)?.label.split(" ")[1] });
        }
        
      })
      .catch((err) => {
        showToastError(err.response.data.message)      
      });
  }, [])

  return (
    <>
      {role === "Lecteur" ? (
        <p className="3xl:text-md text-sm font-thin mb-12">{formData.firstName} {formData.lastName}</p>
      ) : (
        <Select
          label="Collaborateur"
          name="idUser"
          value={formData.idUser || ""}
          onChange={handleSelectChange}
          fetchOptions={users}
          disabled={role === "Lecteur"}
          className="w-60 font-Nunito"
        />
      )}
    </>
  )
}

export default Users;